import React, { useEffect, useState } from "react";
import { Dropdown} from "react-bootstrap";
import { Link } from "react-router-dom";
import { ImageElement } from "../../../components";
import { AuthSidebar } from "../index";

function AuthHeader() {
    <AuthSidebar/>
    const [isActive, setActive] = useState(false);
    const [navbarHeight, setNavbarHeight] = useState();
    const [scroll, setScroll] = useState(0);
    const ToggleClass = () => {
      setActive(!isActive); 
    };
    if(isActive){
      document.querySelector('body').classList.add('openSidebar')
    }else{
      document.querySelector('body').classList.remove('openSidebar')
    }
    useEffect(() =>{
      setTimeout(() => {
          let navbar = document.querySelector(".afterloginHeader").clientHeight;
          setNavbarHeight(navbar)
          document.querySelector("body").style.paddingTop = `${navbar}px`;
          document.querySelector(".sideBar").style.top = `${navbar}px`;
          document.querySelector(".sideBar").style.height = `${window.innerHeight - navbar}px`;
        }, 300);
    })
    useEffect(() => {
      document.addEventListener("scroll", () => {
        const scrollCheck = window.scrollY > 50
        if (scrollCheck !== scroll) {
          setScroll(scrollCheck)
        }
      })
    })
    return (
      <>
          <header className={`header afterloginHeader bg-white d-flex align-items-center justify-content-between ${scroll ? 'scroll' : ''}`}>
            <div className="afterloginHeader_left">
                <ul className="list-inline mb-0">
                    <li className="list-inline-item">
                        <Link to="" className="sttglBtn rounded-circle" onClick={() => ToggleClass()}><em className={`${isActive ? 'gg-close' : 'gg-bar'}`}></em></Link>
                    </li>
                    <li className="list-inline-item">
                        <Link to="/home">
                            <ImageElement className="logo" source="logo.svg" alt="logo" />
                        </Link>
                    </li>
                </ul>
            </div>
          </header>
          <AuthSidebar navbar={navbarHeight} />
      </>
    );
}


export default AuthHeader;

